import React, { createContext, useContext, useState, useEffect } from 'react';
import Cookies from 'js-cookie';

const AutenticacaoContexto = createContext();

export const AutenticacaoProvedora = ({ children }) => {
  const [usuario, setUsuario] = useState(null);
  const [token, setToken] = useState(null);
  const [carregando, setCarregando] = useState(true);

  // Verifica se existe token salvo nos cookies ao carregar
  useEffect(() => {
    const tokenSalvo = Cookies.get('token_autenticacao');
    if (tokenSalvo) {
      setToken(tokenSalvo);
    }
    setCarregando(false);
  }, []);

  const fazerLogin = (novoToken, nomeUsuario) => {
    setToken(novoToken);
    setUsuario(nomeUsuario);
    // Salva token nos cookies por 1 hora
    Cookies.set('token_autenticacao', novoToken, { 
      expires: 1,
      secure: process.env.NODE_ENV === 'production',
      sameSite: 'Lax'
    });
  };

  const fazerLogout = () => {
    setToken(null);
    setUsuario(null);
    Cookies.remove('token_autenticacao');
  };

  return (
    <AutenticacaoContexto.Provider value={{ usuario, token, carregando, fazerLogin, fazerLogout }}>
      {children}
    </AutenticacaoContexto.Provider>
  );
};

export const useAutenticacao = () => {
  const contexto = useContext(AutenticacaoContexto);
  if (!contexto) {
    throw new Error('useAutenticacao deve ser usado dentro de AutenticacaoProvedora');
  }
  return contexto;
};
